module.exports = "/_next/static/images/HeroBackground-e6983e04889987bdb04d3b301731e60a.png";